/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/prop-types */
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import LoadingOverlay from 'react-loading-overlay';
import { makeStyles } from '@material-ui/styles';
import { OrderHeader } from './components';
import { OrderContentJV} from './components';
import { OrderContentJVV} from './components';
import { OrderContentJVP} from './components';
import { OrderContentJVI} from './components';
import { OrderContentRO} from './components';
import { OrderContentROJ} from './components';
import { OrderContentROR} from './components';
import { OrderContentRE} from './components';
import { OrderContentREA} from './components';
import { OrderContentRES} from './components';
import { OrderContentRET} from './components';
import { OrderContentUG} from './components';
import { OrderContentPI} from './components';
import { OrderContentJO} from './components';
import { OrderContentSV} from './components';
import { OrderFooter } from './components';
import { selectOtherOverlaySpinner } from '../../redux/other/other.selectors'
import { selectOrderCurrentProduct, selectOrderUpdatedOrder, selectOrderExpoPrefill } from '../../redux/order/order.selectors';
import { setOpenEditItem, resetErrors } from '../../redux/other/other.actions';
import { setCurrentItem, setUpdatedOrder, setExpoPrefill } from '../../redux/order/order.actions';
import { buildPrefillItemFromExpo } from '../../utils/orderWorkflow';
import { t } from '../../i18n';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
}));

const Order = (props) => {
  const classes = useStyles();
  const {
    overlaySpinner,
    currentProduct,
    updatedOrder,
    expoPrefill,
    setOpenEditItem,
    setCurrentItem,
    resetErrors,
    setExpoPrefill,
    setUpdatedOrder
  } = props;

  useEffect(() => {
    if (!expoPrefill || !currentProduct?.cod) {
      return;
    }
    const productSubTip = currentProduct.subTip || '';
    if (expoPrefill.productCode !== currentProduct.cod) {
      return;
    }
    if ((expoPrefill.productSubTip || '') !== productSubTip) {
      return;
    }
    if (!updatedOrder || Object.keys(updatedOrder).length === 0) {
      return;
    }

    if (!updatedOrder.clientClient) {
      setUpdatedOrder({
        ...updatedOrder,
        clientClient: t('order.prefillClientPlaceholder')
      });
    }

    const prefillItem = buildPrefillItemFromExpo(expoPrefill, currentProduct);
    setCurrentItem(prefillItem);
    resetErrors();
    setOpenEditItem({open:true, title:t('order.addLineTitle'), add:true});
    setExpoPrefill(null);
  }, [expoPrefill, currentProduct, updatedOrder, setCurrentItem, resetErrors, setOpenEditItem, setExpoPrefill, setUpdatedOrder]);

  const product = () => {
    switch(currentProduct.cod) {
      case 'jv':   
        switch(currentProduct.subTip) {
          case 'JVV':
          return <OrderContentJVV/>;
          case 'JVP':
          return <OrderContentJVP/>;
          case 'JVI':
          return <OrderContentJVI/>;
          case '':
          return <OrderContentJV/>;
          default:
          return <OrderContentJV/>;
        }

      case 'ro':  
      switch(currentProduct.subTip) { 
          case 'ROJ':
            return <OrderContentROJ/>;
          case 'ROR':
            return <OrderContentROR/>;
          default:
            return <OrderContentRO/>;
        }
        
      
        case 're': 
        switch(currentProduct.subTip) {
          case 'REA':
            return <OrderContentREA/>;
          case 'RES':
            return <OrderContentRES/>;
          case 'RET':
            return <OrderContentRET/>;
          case '':
            return <OrderContentRE/>;
        }
        
      case 'ug':   
        return <OrderContentUG/>;
      case 'pi':  
        return <OrderContentPI/>;
      case 'jo':  
        return <OrderContentJO/>;
      case 'sv':
        return null;
      case 'ex':
        return null;
      default: 
        return <h1>{t('order.noProductTypeSet')}</h1>
    }
  }

  return (
   
    <LoadingOverlay
      active={overlaySpinner}
      spinner
      text={t('common.loading')}
    >
      <div className={classes.root}>
        <OrderHeader/>
        {product()}
        <OrderFooter/>
      </div>
    </LoadingOverlay>
    
  );
};

const mapStateToProps=state=>({
  overlaySpinner:selectOtherOverlaySpinner(state),
  currentProduct:selectOrderCurrentProduct(state),
  updatedOrder:selectOrderUpdatedOrder(state),
  expoPrefill:selectOrderExpoPrefill(state)

})

const mapDispatchToProps=dispatch=>({
  setOpenEditItem:payload=>dispatch(setOpenEditItem(payload)),
  resetErrors:()=>dispatch(resetErrors()),
  setCurrentItem:item=>dispatch(setCurrentItem(item)),
  setUpdatedOrder:order=>dispatch(setUpdatedOrder(order)),
  setExpoPrefill:payload=>dispatch(setExpoPrefill(payload))
})

export default connect(mapStateToProps,mapDispatchToProps)(Order) ;
